import {TemplatePatExam} from 'template'

const PatientExamination = () => {
  // Pemeriksaan Pasien
  return <TemplatePatExam title="Pemeriksaan Pasien" />
}

export default PatientExamination
